import { LAYOUT_COLUMN__base } from './LAYOUT_COLUMN__base';

interface PROPS {
  could_be_hidden?: boolean;
  children?: React.ReactNode;
}

export function LAYOUT_COLUMN__right({ children = null, could_be_hidden = false }: PROPS) {
  return (
    <LAYOUT_COLUMN__base {...{ could_be_hidden }} class_name="info__column_right border-l">
      {children}
    </LAYOUT_COLUMN__base>
  );
}
